import React from 'react';
import { motion } from 'framer-motion';
import { XCircleIcon } from 'lucide-react';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
export function ProblemSection() {
  const {
    ref,
    isVisible
  } = useScrollAnimation(0.1);
  return <section id="producto" className="py-20 md:py-32 bg-[#050505] relative overflow-hidden" data-id="element-257">
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-white/10 to-transparent" data-id="element-258" />

      <div className="container mx-auto px-4 max-w-4xl" data-id="element-259">
        <div className="flex justify-center mb-16" data-id="element-260">
          <motion.div ref={ref} initial={{
          opacity: 0,
          y: 20
        }} animate={isVisible ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.5
        }} className="glass-card p-8 md:p-12 rounded-3xl relative group hover:bg-white/[0.05] transition-colors w-full text-center" data-id="element-261">
            <XCircleIcon className="w-12 h-12 text-red-500 mb-6 mx-auto" data-id="element-262" />
            <h3 className="text-2xl md:text-3xl font-bold text-white mb-4" data-id="element-263">
              Tools Genéricas = Output Genérico
            </h3>
            <p className="text-gray-400 leading-relaxed text-lg md:text-xl max-w-2xl mx-auto" data-id="element-264">
              Canva, Midjourney, ChatGPT... todo lindo, pero nada vende. Porque
              no están diseñados para ads que conviertan.
            </p>
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={isVisible ? {
        opacity: 1,
        scale: 1
      } : {}} transition={{
        delay: 0.3,
        duration: 0.5
      }} className="glass-card border-l-4 border-l-purple-500 p-8 md:p-10 rounded-2xl max-w-3xl mx-auto text-center bg-gradient-to-r from-purple-900/10 to-transparent" data-id="element-265">
          <p className="text-xl md:text-2xl font-medium text-white mb-6" data-id="element-266">
            "Mientras vos perfeccionás un diseño, tu competencia ya testeó 50."
          </p>
          <a href="#pricing" className="text-purple-400 hover:text-purple-300 font-bold text-lg flex items-center justify-center gap-2 group" data-id="element-267">
            Hay una forma mejor
            <span className="group-hover:translate-x-1 transition-transform" data-id="element-268">
              →
            </span>
          </a>
        </motion.div>
      </div>
    </section>;
}